module.exports = __webpack_public_path__ + "static/media/logo-ncaa.7af5394f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/assets/logo-ncaa.png
// module id = 309
// module chunks = 0